import { render } from "./InputTelephone.vue?vue&type=template&id=0b404916&scoped=true"
import script from "./InputTelephone.vue?vue&type=script&lang=js"
export * from "./InputTelephone.vue?vue&type=script&lang=js"

import "./InputTelephone.vue?vue&type=style&index=0&id=0b404916&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b404916"]])

export default __exports__